export const DATA_TESTID_CALCULATE_QUANTITY_BUTTON = 'calculate-quantity-button';
export const CALCULATORS_LAMINATE_PROJECT_UPDATED_EVENT = 'calculators:laminatProjectUpdated';
